import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import type Employee from 'modules/employees/store/models/Employee'
import { filterEmployeesByPayrollPolicyPeriod } from 'modules/payroll_bundle/lib/filterEmployeesByPayrollPolicyPeriod'
import { usePolicyPage } from 'modules/payroll_bundle/lib/policyPageContext'
import type { Policies } from 'modules/payroll_bundle/store/collections/policies'
import type PolicyPeriod from 'modules/payroll_bundle/store/models/PolicyPeriod'

export interface Props {
  periodIndex: number
  policyPeriods: PolicyPeriod[]
  employees: Employee[]
  policies: Policies
  loadingPolicyData: boolean
}

const useEmployeesByPeriod = ({
  employees,
  policies,
  policyPeriods,
  periodIndex,
  loadingPolicyData,
}: Props) => {
  const policyPeriod = policyPeriods[periodIndex]
  const { policyCurrentContracts: currentContracts, loading: loadingContracts } = usePolicyPage()
  const loading = loadingPolicyData || loadingContracts
  const filteredEmployees = useUnsafeMemo(
    () => {
      const canFilter = !loading && policyPeriod

      if (!canFilter) return []

      return filterEmployeesByPayrollPolicyPeriod({
        employees,
        policyPeriod,
        currentContracts,
        policies,
      })
    },
    [policyPeriod?.id, loading] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return filteredEmployees
}

export default useEmployeesByPeriod
